import { memo, useCallback, useEffect, useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { getDashboardMainScrollElement, scrollDashboardMainScrollToTop } from '../../utils/appMainScroll';

const SHOW_TOP_AFTER_PX = 320;

/** 首页右下角：滚离后显示「回到顶部」（样式与统计页 FAB 一致） */
const DashboardBackToTopButton = () => {
	const [showBackToTop, setShowBackToTop] = useState(false);

	useEffect(() => {
		const scrollEl = getDashboardMainScrollElement();
		if (!scrollEl) return undefined;

		const sync = () => {
			setShowBackToTop(scrollEl.scrollTop > SHOW_TOP_AFTER_PX);
		};
		sync();
		scrollEl.addEventListener('scroll', sync, { passive: true });
		window.addEventListener('resize', sync, { passive: true });
		return () => {
			scrollEl.removeEventListener('scroll', sync);
			window.removeEventListener('resize', sync);
		};
	}, []);

	const handleBackToTop = useCallback(() => {
		scrollDashboardMainScrollToTop({ smooth: true });
	}, []);

	if (!showBackToTop) return null;

	return (
		<div className='statistics-page-fabs' role='group' aria-label='首页快捷操作'>
			<div className='statistics-page-fabs__capsule'>
				<button type='button' className='statistics-page-fabs__btn' onClick={handleBackToTop} title='回到顶部' aria-label='回到顶部'>
					<FontAwesomeIcon icon='chevron-up' className='statistics-page-fabs__icon' />
				</button>
			</div>
		</div>
	);
};

export default memo(DashboardBackToTopButton);
